import {
    Content as RadixDialogContent,
    Portal,
    Overlay,
    type DialogContentProps as RadixDialogContentProps,
} from "@radix-ui/react-dialog";
import clsx from "clsx";
import { forwardRef } from "react";

import { Size } from "../types";
import { DEFAULT_SIZE } from "../utils";

import styles from "./content.module.css";

type DialogContentProps = RadixDialogContentProps & {
    size?: Size;
};

const DialogContent = forwardRef<HTMLDivElement, DialogContentProps>((props, ref) => {
    const { className, children, size = DEFAULT_SIZE, ...otherProps } = props;

    return (
        <Portal>
            <Overlay className={styles.overlay}>
                <RadixDialogContent
                    {...otherProps}
                    ref={ref}
                    className={clsx(styles.content, className)}
                    data-size={size}
                    // NOTE: to disable aria-describedby, we need to pass undefined,
                    //       otherwise we need to add `Description` component
                    //       source: https://www.radix-ui.com/primitives/docs/components/dialog#description
                    aria-describedby={undefined}
                >
                    {children}
                </RadixDialogContent>
            </Overlay>
        </Portal>
    );
});

DialogContent.displayName = "Dialog.Content";

export { DialogContent };
export type { DialogContentProps };
